import { useAppSelector } from "@assessment/store/store";
import { Question } from "@assessment/types/assessmentOngoing";
import { useTranslation } from "react-i18next";
import ShowHint from "../../../hint-explanation/showHint";

interface HintProps {
  question: Question;
  showHintSection: boolean;
  revealedHintsCount: number;
}

const HintAndExplanation = ({
  question,
  showHintSection,
  revealedHintsCount
}: HintProps) => {
  const { t } = useTranslation();
  const hints = question?.hint || [];

  const preAssessmentData = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData
  );

  return (
    <>
      <div className="my-5">
        {preAssessmentData?.questionConfig?.showExplanation &&
          Array.isArray(question?.codingexplanation) &&
          question.codingexplanation.length > 0 && (
            <div className="mt-6" id="explanation-section">
              <p className="font-semibold text-secondary/90 mb-2">
                {t("assessment.coding.explanation")}
              </p>
              {question.codingexplanation.map((exp, i) => (
                <div
                  key={i}
                  dangerouslySetInnerHTML={{ __html: exp }}
                  style={{ whiteSpace: "pre-line" }}
                />
              ))}
            </div>
          )}
      </div>
      {showHintSection &&
        preAssessmentData?.questionConfig?.showHint &&
        question?.hint?.length > 0 && (
          <div className="my-5" id="hints-section">
            <p className="font-semibold text-secondary/90 mb-2">
              {t("assessment.coding.hints")}
            </p>
            {hints.slice(0, revealedHintsCount).map((hint, index) => (
              <div
                key={index}
                id={`hint-${index}`}
                className="mt-3 animate-fadeInUp"
                style={{
                  animationDelay: `${index * 100}ms`,
                  animationFillMode: "both"
                }}
              >
                <ShowHint hints={[hint]} visibleCount={1} />
              </div>
            ))}
          </div>
        )}
    </>
  );
};

export default HintAndExplanation;
